import { useMemo } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material';
import isEmpty from 'lodash/isEmpty';

import type { NavigationItemData } from '@/components/NavBar/components/NavigationItem';
import { useDashboard } from '@/features/Dashboard/api';
import { DASHBOARD_NEW_SECTION_LABEL } from '@/features/Dashboard/constants/names';

export const useDashboardMenuItems = (): NavigationItemData[] => {
  const { data } = useDashboard();
  const theme = useTheme();

  return useMemo(() => {
    const dashboardItems =
      data && !isEmpty(data)
        ? Object.keys(data).map(name => ({
            key: name,
            id: name,
            name,
            path: `/dashboard/${encodeURIComponent(name)}`
          }))
        : [];

    // Always add "Create Dashboard" button at the end
    return [
      ...dashboardItems,
      {
        key: 'new-dashboard',
        id: 'new-dashboard',
        name: DASHBOARD_NEW_SECTION_LABEL,
        path: '/dashboard/new',
        alignIconWithTopLevel: true,
        icon: (
          <AddIcon
            sx={{
              fontSize: 24
            }}
          />
        ),
        textSx: {
          color: theme.palette.text.disabled
        }
      }
    ];
  }, [data, theme.palette.text.disabled]);
};
